<template>
        <ul class="nav_breadcrumbs">
            <li>
                <router-link to="/modules/home">{{lang.LBL_HOME}}</router-link>
            </li>
            <li>
                <router-link to="/modules/administration">{{lang.LBL_ADMIN}}</router-link>
            </li>
        </ul>

</template>
<script>
    import lang from "@/views/modules/Administration/language/en";
    export default {
        name: "breadcrumbs",
        data() {
            return {
                lang: [],
            }
        },
        mounted() {
            this.lang = lang;
        },

    }
</script>